// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__z7JI8","titleWrapper":"styles_titleWrapper__D_ZIj"};